// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e9094ea1","455":"bc22946b"}[chunkId] + ".chunk.js";
};